export default "__VITE_ASSET__Dx0UxkcP__"